<template>
    <div class="home-all">
        <home1 v-if="$parent.company.config.indexStyle === 1"></home1>
        <home2 v-if="$parent.company.config.indexStyle === 2"></home2>
        <div class="footer ac" :class="$parent.company.config.indexStyle === 1 ? 'fu' : ''">
            <span v-if="$parent.company.config.footerInfo.copyright != ''" v-html="$parent.company.config.footerInfo.copyright"></span>
            <span v-if="$parent.company.config.footerInfo.phone != ''"><i class="icons foot-phone"></i>{{$parent.company.config.footerInfo.phone}}</span>
            <span v-if="$parent.company.config.footerInfo.wxName != ''"><i class="icons foot-wx"></i>{{$parent.company.config.footerInfo.wxName}}</span>
            <span v-if="$parent.company.config.footerInfo.email != ''"><i class="icons foot-email"></i>{{$parent.company.config.footerInfo.email}}</span>
            <span v-if="$parent.company.config.footerInfo.qq != ''"><i class="icons foot-qq"></i>{{$parent.company.config.footerInfo.qq}}</span>
        </div>
	</div>
</template>
<script>
import home1 from './home1.vue';
import home2 from './home2.vue';
export default {
    components:{home1,home2},
    data() {
        return {
           
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            
        }) 
    },
    created() {
		if(process.env.NODE_ENV !== "development"){
			let url = window.location.href;
			window.location.href = url + 'api/index';
		}
    },
    methods: {
        
	}
}
</script>



// WEBPACK FOOTER //
// src/page/index/index.vue